<template>
  <div class="tab-pane">
    <div class="pane-item trademark">
      <div class="trademark-item">
        <div class="pane-item-title">商标：链聚</div>
        <img src="@/assets/about/sb1.png" />
      </div>
      <div class="trademark-item">
        <div class="pane-item-title">商标：千尺</div>
        <img src="@/assets/about/sb2.png" />
      </div>
      <div class="trademark-item">
        <div class="pane-item-title">商标：千尺链</div>
        <img src="@/assets/about/sb3.png" />
      </div>
      <div class="trademark-item">
        <div class="pane-item-title">商标：千尺溯源</div>
        <img src="@/assets/about/sb4.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "copyright-software",

  data() {
    return {};
  },
  created() {},
  computed: {},

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    choose(index) {
      this.chooseIndex = index;
    },
  },
};
</script>
<style lang="less" scoped src="./copyright.less">

</style>